import { render, staticRenderFns } from "./svgSkype.vue?vue&type=template&id=69413fc4&scoped=true"
import script from "./svgSkype.vue?vue&type=script&lang=js"
export * from "./svgSkype.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69413fc4",
  null
  
)

export default component.exports